import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FaStar } from 'react-icons/fa';

const ReviewsPageContainer = styled.div`
  max-width: 1200px;
  margin: 4rem auto;
  padding: 0 2rem;
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: 2.8rem;
  margin-bottom: 1.5rem;
  color: #333;
`;

const PageSubtitle = styled.p`
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 3rem; 
`;

const TrustpilotWidgetContainer = styled.div`
  /* The Trustpilot widget will be injected here */
  /* You can add styling for min-height or background as a fallback */
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ReviewButton = styled.a`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  background-color: #005eb8;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: bold;
  transition: background-color 0.3s, transform 0.2s;

  &:hover {
    background-color: #004a94;
    transform: translateY(-2px);
  }
`;

const StarRatingContainer = styled.div`
  display: flex;
  gap: 0.3rem;
  color: #ffc107; /* A gold color for stars */
`;

const Reviews = () => {
    useEffect(() => {
        // This script will find the widget `div` and load the reviews into it.
        // It's safe to call multiple times; Trustpilot's script handles it.
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(document.getElementById('trustpilot-widget'));
        }
    }, []);

    return (
        <ReviewsPageContainer>
            <PageTitle>Our Customer Reviews</PageTitle>
            <PageSubtitle>See what our customers are saying about us on Trustpilot.</PageSubtitle>
            <TrustpilotWidgetContainer>
                <ReviewButton href="https://uk.trustpilot.com/review/theletterdoctor.co.uk?utm_medium=trustbox&utm_source=TrustBoxReviewCollector" target="_blank" rel="noopener noreferrer">
                    <span>See our reviews here</span>
                    <StarRatingContainer>
                        {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                    </StarRatingContainer>
                </ReviewButton>
            </TrustpilotWidgetContainer>
        </ReviewsPageContainer>
    );
};

export default Reviews;